import { supabase } from "@/services/supabase/createClient";
import { onError } from "@/services/onError";

export const deleteTeam = async (teamId: string) => {
  const { error } = await supabase.from("teams").delete().eq("team_id", teamId);
  if (error) {
    onError(error);
  }
};
